import React from 'react'
import PropTypes from 'prop-types'
import LocationOn from '@material-ui/icons/LocationOn'
import Fingerprint from '@material-ui/icons/Fingerprint'
import DoneAll from '@material-ui/icons/DoneAll'
import Email from '@material-ui/icons/Email'
import LockOpen from '@material-ui/icons/LockOpen'
import Typography from '@material-ui/core/Typography'
import CustomInputAdornment from 'components/CustomInput/CustomInputAdornment'
import Button from 'components/CustomButtons/Button.jsx'
import CircularLoadingButton from 'views/Components/CircularLoadingButton'
import { connect } from 'react-redux'
import { renderSnackbar } from 'actions/snackbar'
import api from 'api'
import validate, { constraints } from 'services/formValidator'
import { parseErrorViolations } from 'services/utils'
import { withStyles } from '@material-ui/core'
import style from 'assets/css/style.jsx';
import ReCAPTCHA from "react-google-recaptcha";

const styles = require(`../../assets/css/style.jsx`).default;

const login_constraints = {
  companyId: [constraints.isRequired],
  postalCode: [constraints.isRequired],
  email: [constraints.isRequired, constraints.isEmail],
  plainPassword: [constraints.isRequired],
  confirmPassword: [constraints.isRepetead('plainPassword')]
}

class RegisterForm extends React.Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
    this.state = {
        errors: {},
        isVerified: false,
        data:{}
    };
    this.recaptchaRef = React.createRef();
    this.dataForm = null;
  }

  verifyCallback(response){
    if(response){
      this.setState({isVerified:true})
      this.httpsRegister(this.dataForm)
      this.dataForm = null;
    }
  }

  httpsRegister(data) {
    let errors = validate(data, login_constraints)
    if (Object.keys(errors).length === 0) {
      this.setState({btnLoading: true})
      api.auth.register(data)
        .then(resp => {
          this.props.history.push('/login')
          this.props.renderSnackbar({
            color: 'success',
            message: 'Votre compte a bien été créé.'
          })
        })
        .catch(error => {
          errors = parseErrorViolations(error)
          this.setState({ errors, btnLoading: false })
        })
    }
    this.setState({
      errors
    })
  }

  handleSubmit = e => {
    e.preventDefault();
    this.recaptchaRef.current.execute();
    const data = {
      companyId: e.target.companyId.value,
      postalCode: e.target.postalCode.value,
      email: e.target.email.value,
      plainPassword: e.target.plainPassword.value,
      confirmPassword: e.target.confirmPassword.value
    }
    if(this.state.isVerified){
        this.httpsRegister(data)
      
    }
    else{
      this.dataForm = data
    }
  }

  render() {
    const { classes } = this.props
    const { errors, btnLoading } = this.state

    return (
      <form className={classes.form} onSubmit={(e) => this.handleSubmit(e)}>
        {!!errors.global && <Typography variant="caption" color="error">Erreur : {errors.global}</Typography>}
        <CustomInputAdornment 
          icon={Fingerprint}
          error={!!errors.companyId}
          helpText={errors.companyId}
          inputProps={{
            placeholder: 'Code interne...',
            name: 'companyId'
          }}
        />
        <CustomInputAdornment
          error={!!errors.postalCode}
          helpText={errors.postalCode}
          icon={LocationOn}
          inputProps={{
            placeholder: 'Code postal...',
            name: 'postalCode'
          }}
        />
        <CustomInputAdornment
          error={!!errors.email}
          helpText={errors.email}
          icon={Email}
          inputProps={{
            placeholder: 'Email...',
            name: 'email'
          }}
        />
        <CustomInputAdornment
          error={!!errors.plainPassword}
          helpText={errors.plainPassword}
          icon={LockOpen}
          inputProps={{
            placeholder: 'Mot de passe...',
            name: 'plainPassword',
            type: 'password'
          }}
        />
        <CustomInputAdornment
          error={!!errors.confirmPassword}
          helpText={errors.confirmPassword}
          icon={DoneAll}
          inputProps={{
            placeholder: 'Confirmation mot de passe...',
            name: 'confirmPassword',
            type: 'password'
          }}
        />
        
        <div className={classes.center}>
          <Button
            className = {classes.btnRegister}
            style = {styles.btnLogin}
            type='submit'>
            Enregistrer
          </Button>
        </div>

        <ReCAPTCHA
          ref={this.recaptchaRef}
          sitekey="6LfdZcwZAAAAAK1NIvgNTS5T8b8JW3ef3wf-AHsy"
          size="invisible"
          onChange={this.verifyCallback}
          theme="dark"
        />

      </form>
    );
  }
}

RegisterForm.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  renderSnackbar: PropTypes.func.isRequired
}

export default connect(null, { renderSnackbar })(withStyles(style)(RegisterForm))


// WEBPACK FOOTER //
// ./src/views/Forms/RegisterForm.jsx